// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Main container */
.styling-product-design-container {
    display: flex;
    align-items: flex-start; /* Align items from the top */
    justify-content: space-between;
    padding: 100px; /* Reduced padding to avoid large top space */
    background-color: #f5f5f5;
    border-radius: 8px;
    font-family: Arial, sans-serif;

    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
    gap: 20px;
    margin-top: 0; /* Ensures it starts from the top without additional margin */
}

/* Left Section - Image */
.styling-product-design-image {
    position: relative;
    width: 35%;
    order: 2; /* Place image on the left */
    padding: 10px 0;
    margin-top: -20px;
}

.services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
}

/* Right Section - Content */
.styling-product-design-text {
    width: 65%;
    order: 2; /* Place content on the right */
    margin-top: -90px
}

.styling-product-design-text h1 {
    font-size: 2rem; /* Main headline font size */
    color: #000;
    margin-bottom: 10px;
}

div.styling-product-design-text p {
    font-size: 1.2em;
    color: #555;
    margin-bottom: 20px;
}

.services-list {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    list-style: none;
    padding: 0;
}

.services-list li {
    width: 45%;
    font-size: 1rem; /* List item font size slightly larger for emphasis */
    color: #333;
}

/* Responsive Design */
@media (max-width: 768px) {
    .styling-product-design-container {
        flex-direction: column; /* Stack items for smaller screens */
        align-items: flex-start; /* Align items from the top */
        text-align: left; /* Align text to the left */
        gap: 20px;
        padding: 20px; /* Adjust padding for smaller screens */
        padding-top:30px;
    }

    .styling-product-design-text {
        width: 100%;
        order: 2; /* Maintain order for responsive layout */
        margin-bottom:30px;
        margin-top:-60px
    }

    .styling-product-design-image {
        margin-top:120px;
        width: 100%;
        order: 1; /* Maintain order for responsive layout */
    }

    .services-list li {
        width: 100%;
    }
    

}

/* Media Query for 1366x768 screen size */
@media screen and (min-width: 1380px) and (max-width: 1919px) {
    .styling-product-design-container {
        padding: 100px; /* Adjusted padding for medium screens */
        gap: 15px; /* Reduced gap for balanced layout */
    }

    .styling-product-design-text {
        margin-top: -80px; /* Adjusted spacing */
    }

    .styling-product-design-text h1 {
        font-size: 1.8rem; /* Slightly smaller headline font size */
    }

    div.styling-product-design-text p {
        font-size: 0.9rem; /* Adjusted paragraph font size */
    }

    .styling-product-design-image {
        width: 28%; /* Slightly larger image width for balance */
        margin-top: -20px;
    }

    .services-list li {
        width: 48%; /* Adjusted list item width for medium screens */
        font-size: 0.9rem; /* Reduced font size */
    }
}

/* Media Query for 1920px and larger screen sizes */
@media screen and (min-width: 1920px) {
    .styling-product-design-container {
        padding: 100px; /* Larger padding for spacious layout */
        gap: 25px; /* Enhanced gap for better spacing */
    }

    .styling-product-design-text {
        margin-top: -100px; /* Increased spacing for alignment */
    }

    .styling-product-design-text h1 {
        font-size: 2.2rem; /* Larger headline font size */
    }

    div.styling-product-design-text p {
        font-size: 1.1rem; /* Increased paragraph font size */
    }

    .styling-product-design-image {
        width: 33%; /* Slightly reduced image width for proportion */
        margin-top: -30px;
    }

    .services-list li {
        width: 45%; /* Consistent width for list items */
        font-size: 1.1rem; /* Larger font size for readability */
    }
}`, "",{"version":3,"sources":["webpack://./src/components/StylingProductDesign/StylingProductDesign.css"],"names":[],"mappings":"AAAA,mBAAmB;AACnB;IACI,aAAa;IACb,uBAAuB,EAAE,6BAA6B;IACtD,8BAA8B;IAC9B,cAAc,EAAE,6CAA6C;IAC7D,yBAAyB;IACzB,kBAAkB;IAClB,8BAA8B;;IAE9B,wCAAwC;IACxC,SAAS;IACT,aAAa,EAAE,6DAA6D;AAChF;;AAEA,yBAAyB;AACzB;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAE,4BAA4B;IACtC,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA,4BAA4B;AAC5B;IACI,UAAU;IACV,QAAQ,EAAE,+BAA+B;IACzC;AACJ;;AAEA;IACI,eAAe,EAAE,4BAA4B;IAC7C,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,UAAU;IACV,eAAe,EAAE,qDAAqD;IACtE,WAAW;AACf;;AAEA,sBAAsB;AACtB;IACI;QACI,sBAAsB,EAAE,oCAAoC;QAC5D,uBAAuB,EAAE,6BAA6B;QACtD,gBAAgB,EAAE,2BAA2B;QAC7C,SAAS;QACT,aAAa,EAAE,uCAAuC;QACtD,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,QAAQ,EAAE,yCAAyC;QACnD,kBAAkB;QAClB;IACJ;;IAEA;QACI,gBAAgB;QAChB,WAAW;QACX,QAAQ,EAAE,yCAAyC;IACvD;;IAEA;QACI,WAAW;IACf;;;AAGJ;;AAEA,yCAAyC;AACzC;IACI;QACI,cAAc,EAAE,wCAAwC;QACxD,SAAS,EAAE,oCAAoC;IACnD;;IAEA;QACI,iBAAiB,EAAE,qBAAqB;IAC5C;;IAEA;QACI,iBAAiB,EAAE,wCAAwC;IAC/D;;IAEA;QACI,iBAAiB,EAAE,iCAAiC;IACxD;;IAEA;QACI,UAAU,EAAE,4CAA4C;QACxD,iBAAiB;IACrB;;IAEA;QACI,UAAU,EAAE,gDAAgD;QAC5D,iBAAiB,EAAE,sBAAsB;IAC7C;AACJ;;AAEA,mDAAmD;AACnD;IACI;QACI,cAAc,EAAE,uCAAuC;QACvD,SAAS,EAAE,oCAAoC;IACnD;;IAEA;QACI,kBAAkB,EAAE,oCAAoC;IAC5D;;IAEA;QACI,iBAAiB,EAAE,8BAA8B;IACrD;;IAEA;QACI,iBAAiB,EAAE,kCAAkC;IACzD;;IAEA;QACI,UAAU,EAAE,gDAAgD;QAC5D,iBAAiB;IACrB;;IAEA;QACI,UAAU,EAAE,oCAAoC;QAChD,iBAAiB,EAAE,qCAAqC;IAC5D;AACJ","sourcesContent":["/* Main container */\n.styling-product-design-container {\n    display: flex;\n    align-items: flex-start; /* Align items from the top */\n    justify-content: space-between;\n    padding: 100px; /* Reduced padding to avoid large top space */\n    background-color: #f5f5f5;\n    border-radius: 8px;\n    font-family: Arial, sans-serif;\n\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n    gap: 20px;\n    margin-top: 0; /* Ensures it starts from the top without additional margin */\n}\n\n/* Left Section - Image */\n.styling-product-design-image {\n    position: relative;\n    width: 35%;\n    order: 2; /* Place image on the left */\n    padding: 10px 0;\n    margin-top: -20px;\n}\n\n.services-image {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n}\n\n/* Right Section - Content */\n.styling-product-design-text {\n    width: 65%;\n    order: 2; /* Place content on the right */\n    margin-top: -90px\n}\n\n.styling-product-design-text h1 {\n    font-size: 2rem; /* Main headline font size */\n    color: #000;\n    margin-bottom: 10px;\n}\n\ndiv.styling-product-design-text p {\n    font-size: 1.2em;\n    color: #555;\n    margin-bottom: 20px;\n}\n\n.services-list {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 10px;\n    list-style: none;\n    padding: 0;\n}\n\n.services-list li {\n    width: 45%;\n    font-size: 1rem; /* List item font size slightly larger for emphasis */\n    color: #333;\n}\n\n/* Responsive Design */\n@media (max-width: 768px) {\n    .styling-product-design-container {\n        flex-direction: column; /* Stack items for smaller screens */\n        align-items: flex-start; /* Align items from the top */\n        text-align: left; /* Align text to the left */\n        gap: 20px;\n        padding: 20px; /* Adjust padding for smaller screens */\n        padding-top:30px;\n    }\n\n    .styling-product-design-text {\n        width: 100%;\n        order: 2; /* Maintain order for responsive layout */\n        margin-bottom:30px;\n        margin-top:-60px\n    }\n\n    .styling-product-design-image {\n        margin-top:120px;\n        width: 100%;\n        order: 1; /* Maintain order for responsive layout */\n    }\n\n    .services-list li {\n        width: 100%;\n    }\n    \n\n}\n\n/* Media Query for 1366x768 screen size */\n@media screen and (min-width: 1380px) and (max-width: 1919px) {\n    .styling-product-design-container {\n        padding: 100px; /* Adjusted padding for medium screens */\n        gap: 15px; /* Reduced gap for balanced layout */\n    }\n\n    .styling-product-design-text {\n        margin-top: -80px; /* Adjusted spacing */\n    }\n\n    .styling-product-design-text h1 {\n        font-size: 1.8rem; /* Slightly smaller headline font size */\n    }\n\n    div.styling-product-design-text p {\n        font-size: 0.9rem; /* Adjusted paragraph font size */\n    }\n\n    .styling-product-design-image {\n        width: 28%; /* Slightly larger image width for balance */\n        margin-top: -20px;\n    }\n\n    .services-list li {\n        width: 48%; /* Adjusted list item width for medium screens */\n        font-size: 0.9rem; /* Reduced font size */\n    }\n}\n\n/* Media Query for 1920px and larger screen sizes */\n@media screen and (min-width: 1920px) {\n    .styling-product-design-container {\n        padding: 100px; /* Larger padding for spacious layout */\n        gap: 25px; /* Enhanced gap for better spacing */\n    }\n\n    .styling-product-design-text {\n        margin-top: -100px; /* Increased spacing for alignment */\n    }\n\n    .styling-product-design-text h1 {\n        font-size: 2.2rem; /* Larger headline font size */\n    }\n\n    div.styling-product-design-text p {\n        font-size: 1.1rem; /* Increased paragraph font size */\n    }\n\n    .styling-product-design-image {\n        width: 33%; /* Slightly reduced image width for proportion */\n        margin-top: -30px;\n    }\n\n    .services-list li {\n        width: 45%; /* Consistent width for list items */\n        font-size: 1.1rem; /* Larger font size for readability */\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
